import React from "react";
import { MdEdit, MdDelete, MdRemoveRedEye } from "react-icons/md";

const SosialyTable = ({ sosialy, loading, onEdit, onDelete, onView }) => {
  // Fonction pour formater le montant en devise (MGA)
  const formatCurrency = (amount) => {
    const numAmount = parseFloat(amount);
    if (isNaN(numAmount)) return "0 Ar";
    
    return new Intl.NumberFormat('fr-MG', {
      style: 'currency',
      currency: 'MGA',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(numAmount);
  };

  // Formatage de la date
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="overflow-hidden rounded-lg shadow-sm border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-700"
            >
              Membre
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 hidden md:table-cell"
            >
              Période
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700"
            >
              Montant
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 hidden lg:table-cell"
            >
              Date
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 hidden sm:table-cell"
            >
              Objet
            </th>
            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
              <span className="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {loading && sosialy.length === 0 ? (
            <tr>
              <td colSpan="6" className="px-3 py-6 text-center text-sm text-gray-500">
                <div className="flex justify-center">
                  <svg className="animate-spin h-5 w-5 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </div>
              </td>
            </tr>
          ) : sosialy.length === 0 ? (
            <tr>
              <td colSpan="6" className="px-3 py-6 text-center text-sm text-gray-500">
                <p>Aucune cotisation trouvée</p>
                <p className="text-xs text-gray-400 mt-1">
                  Créez une nouvelle cotisation en cliquant sur le bouton "Nouvelle Cotisation"
                </p>
              </td>
            </tr>
          ) : (
            sosialy.map((item) => (
              <tr key={item.id_sosialy} className="hover:bg-gray-50 transition-colors">
                <td className="py-4 pl-4 pr-3 text-sm">
                  <div className="font-medium text-gray-900">
                    {item.membre ? item.membre.nom_prenom_membre : "—"}
                  </div>
                  {item.membre && item.membre.com_origin && (
                    <div className="text-xs text-gray-500 mt-1">
                      {item.membre.com_origin}
                    </div>
                  )}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600 hidden md:table-cell">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                    {item.mois_sosialy} {item.annee_sosialy}
                  </span>
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-gray-900">
                  {formatCurrency(item.montant_sosialy)}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600 hidden lg:table-cell">
                  {formatDate(item.date_sosialy)}
                </td>
                <td className="px-3 py-4 text-sm text-gray-600 hidden sm:table-cell">
                  <div className="max-w-xs truncate" title={item.objet_sosialy}>
                    {item.objet_sosialy}
                  </div>
                </td>
                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                  <div className="flex justify-end gap-2">
                    <button
                      onClick={() => onView(item)}
                      className="p-1.5 text-green-600 hover:text-green-900 rounded-md hover:bg-gray-100 transition-colors"
                      title="Voir les détails"
                    >
                      <MdRemoveRedEye className="h-5 w-5" />
                    </button>
                    <button
                      onClick={() => onEdit(item)}
                      className="p-1.5 text-gray-600 hover:text-gray-900 rounded-md hover:bg-gray-100 transition-colors"
                      title="Modifier"
                    >
                      <MdEdit className="h-5 w-5" />
                    </button>
                    <button
                      onClick={() => onDelete(item)}
                      className="p-1.5 text-red-500 hover:text-red-700 rounded-md hover:bg-gray-100 transition-colors"
                      title="Supprimer"
                    >
                      <MdDelete className="h-5 w-5" />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
          
          {/* Ligne pour afficher le total */}
          {sosialy.length > 0 && (
            <tr className="bg-gray-50 font-bold">
              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-700" colSpan="2">
                Total ({sosialy.length} cotisations)
              </td>
              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                {formatCurrency(
                  sosialy.reduce(
                    (sum, item) => sum + parseFloat(item.montant_sosialy || 0),
                    0
                  )
                )}
              </td>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SosialyTable;